export default __webpack_public_path__ + "static/media/building-icon.d6d3a709.svg";